/* Maison Aura, comportamiento del tema. Sin dependencias. */
(function () {
  'use strict';

  var MA = window.MA || {};
  var R = MA.routes || {};
  var raiz = document.documentElement;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CHECK = '<svg class="icono" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var FOCO = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esCarrito() { return document.body.classList.contains('template-cart'); }

  /* ---------- Paneles: menú, carrito y filtros ---------- */
  var abierto = null;
  var ultimoFoco = null;

  function marcarControles(el, valor) {
    if (!el || !el.id) return;
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', valor ? 'true' : 'false'); });
  }

  function abrir(el, origen) {
    if (!el) return;
    if (abierto && abierto !== el) cerrar(abierto, true);
    clearTimeout(el._cerrando);
    ultimoFoco = origen || document.activeElement;
    if (el.hasAttribute('data-overlay')) {
      el.hidden = false;
      void el.offsetWidth; // fuerza el estilo inicial para que la transición corra
    }
    el.classList.add('abierto');
    raiz.classList.add('sin-scroll');
    abierto = el;
    marcarControles(el, true);
    var panel = el.querySelector('[role="dialog"]') || el;
    if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    panel.focus({ preventScroll: true });
  }

  function cerrar(el, sinDevolverFoco) {
    el = el || abierto;
    if (!el) return;
    el.classList.remove('abierto');
    raiz.classList.remove('sin-scroll');
    marcarControles(el, false);
    if (el.hasAttribute('data-overlay')) {
      clearTimeout(el._cerrando);
      el._cerrando = setTimeout(function () {
        if (!el.classList.contains('abierto')) el.hidden = true;
      }, reducido ? 0 : 340);
    }
    if (abierto === el) abierto = null;
    if (!sinDevolverFoco && ultimoFoco && document.contains(ultimoFoco)) ultimoFoco.focus({ preventScroll: true });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (abierto) { cerrar(); return; }
      var buscador = $('#buscador');
      if (buscador && !buscador.hidden) { alternarBuscador(false); return; }
    }
    if (e.key !== 'Tab' || !abierto) return;
    var focos = $$(FOCO, abierto).filter(function (x) { return x.offsetWidth > 0 || x.offsetHeight > 0; });
    if (!focos.length) return;
    var primero = focos[0];
    var ultimo = focos[focos.length - 1];
    var activo = document.activeElement;
    if (e.shiftKey && (activo === primero || !abierto.contains(activo) || activo.getAttribute('role') === 'dialog')) {
      e.preventDefault(); ultimo.focus();
    } else if (!e.shiftKey && (activo === ultimo || !abierto.contains(activo))) {
      e.preventDefault(); primero.focus();
    }
  });

  /* ---------- Buscador ---------- */
  function alternarBuscador(mostrar) {
    var buscador = $('#buscador');
    if (!buscador) return;
    if (typeof mostrar !== 'boolean') mostrar = buscador.hidden;
    buscador.hidden = !mostrar;
    marcarControles(buscador, mostrar);
    if (mostrar) { var i = $('input[type="search"]', buscador); if (i) i.focus(); }
    else { var b = $('[data-buscar]'); if (b) b.focus(); }
  }

  /* ---------- Menú en teléfono: se mueve al body para quedar sobre todo ---------- */
  function moverMenu() {
    var menus = $$('#menu-movil');
    if (!menus.length) return;
    var ultimo = menus[menus.length - 1];
    menus.forEach(function (m) { if (m !== ultimo) m.remove(); });
    if (ultimo.parentNode !== document.body) document.body.appendChild(ultimo);
  }

  /* ---------- Carrito ---------- */
  function cajon() { return $('[data-cajon]'); }

  function actualizarConteo(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
      el.classList.remove('salto');
      if (n > 0 && !reducido) { void el.offsetWidth; el.classList.add('salto'); }
    });
    $$('[data-abrir-carrito]').forEach(function (a) {
      a.setAttribute('aria-label', 'Carrito, ' + n + (n === 1 ? ' perfume' : ' perfumes'));
    });
  }

  function pintarCajon(html) {
    var c = cajon();
    if (!html || !c) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = $('[data-cajon-panel]', doc);
    var panel = $('[data-cajon-panel]', c);
    if (nuevo && panel) panel.innerHTML = nuevo.innerHTML;
    var fuente = $('[data-cart-count-source]', doc);
    if (fuente) actualizarConteo(parseInt(fuente.textContent, 10) || 0);
  }

  function pedir(url, datos) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(datos)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Algo salió mal. Intenta de nuevo.');
        return d;
      });
    });
  }

  function mostrarError(el, mensaje) {
    if (!el) {
      var c = cajon();
      el = c ? $('[data-error-carrito]', c) : null;
      if (c) abrir(c);
    }
    if (el) { el.textContent = mensaje; el.hidden = false; }
    else { window.alert(mensaje); }
  }

  function confirmar(boton) {
    if (!boton) return;
    if (boton.classList.contains('mas')) {
      var antes = boton.innerHTML;
      boton.classList.add('listo');
      boton.innerHTML = CHECK;
      setTimeout(function () { boton.classList.remove('listo'); boton.innerHTML = antes; }, 1400);
      return;
    }
    var t = $('[data-boton-texto]', boton);
    if (t) {
      var previo = t.textContent;
      t.textContent = 'Agregado';
      setTimeout(function () { t.textContent = previo; }, 1400);
    }
  }

  function agregar(form, boton) {
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return;
    var cantidad = parseInt(fd.get('quantity') || '1', 10) || 1;
    var errorEl = $('[data-error-carrito]', form);
    if (errorEl) errorEl.hidden = true;
    var c0 = cajon();
    var dentroDelCajon = !!(c0 && c0.contains(form));
    if (boton) { boton.disabled = true; boton.setAttribute('aria-busy', 'true'); }

    pedir(R.cart_add_url + '.js', {
      items: [{ id: Number(id), quantity: cantidad }],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (d) {
      if (esCarrito()) { window.location.reload(); return; }
      if (d.sections) pintarCajon(d.sections['cart-drawer']);
      if (dentroDelCajon) {
        var p = $('[data-cajon-panel]', c0);
        if (p) p.focus({ preventScroll: true });
        return;
      }
      confirmar(boton);
      if (c0) abrir(c0, boton);
    }).catch(function (err) {
      mostrarError(errorEl, err.message);
    }).then(function () {
      if (boton) { boton.disabled = false; boton.removeAttribute('aria-busy'); }
    });
  }

  var cambiando = false;
  function cambiarLinea(linea, cantidad) {
    if (cambiando) return;
    cambiando = true;
    var c = cajon();
    var panel = c && $('[data-cajon-panel]', c);
    if (panel) panel.setAttribute('aria-busy', 'true');
    pedir(R.cart_change_url + '.js', {
      line: Number(linea),
      quantity: Math.max(0, Number(cantidad)),
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (d) {
      if (d.sections) pintarCajon(d.sections['cart-drawer']);
      var p = c && $('[data-cajon-panel]', c);
      if (p) p.focus({ preventScroll: true });
    }).catch(function (err) {
      mostrarError(null, err.message);
    }).then(function () {
      cambiando = false;
      var p = c && $('[data-cajon-panel]', c);
      if (p) p.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-form], form[data-type="add-to-cart-form"]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var boton = e.submitter && form.contains(e.submitter) ? e.submitter : $('[type="submit"]', form);
    agregar(form, boton);
  });

  /* Si vuelves con el botón Atrás, refresca el carrito por si cambió */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch((R.root_url || '/') + '?sections=cart-drawer').then(function (r) { return r.json(); })
      .then(function (d) { pintarCajon(d['cart-drawer']); }).catch(function () {});
  });

  /* ---------- Clics ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var b;

    if ((b = t.closest('[data-abrir]'))) {
      e.preventDefault();
      abrir(document.getElementById(b.getAttribute('data-abrir')), b);
      return;
    }
    if ((b = t.closest('[data-abrir-carrito]'))) {
      var c = cajon();
      if (c && !esCarrito()) { e.preventDefault(); abrir(c, b); }
      return;
    }
    if ((b = t.closest('[data-cajon] [data-line]'))) {
      e.preventDefault();
      cambiarLinea(b.getAttribute('data-line'), b.getAttribute('data-qty'));
      return;
    }
    if ((b = t.closest('[data-cerrar]'))) {
      var href = b.getAttribute('href');
      if (b.tagName === 'A' && href && href.charAt(0) !== '#') { cerrar(null, true); return; }
      e.preventDefault();
      cerrar();
      return;
    }
    if ((b = t.closest('[data-buscar]'))) { e.preventDefault(); alternarBuscador(); return; }
    if ((b = t.closest('[data-abrir-filtros]'))) { e.preventDefault(); abrir($('[data-filtros]'), b); return; }
    if ((b = t.closest('[data-cerrar-filtros]'))) { e.preventDefault(); cerrar(); return; }

    if ((b = t.closest('.galeria-mini'))) { cambiarFoto(b); return; }

    if ((b = t.closest('[data-barra-boton]'))) {
      var form = document.getElementById('form-producto');
      var principal = form && $('[data-boton-agregar]', form);
      if (!form || !principal || principal.disabled) return;
      if (form.requestSubmit) form.requestSubmit(principal); else principal.click();
      return;
    }
  });

  /* ---------- Página de perfume ---------- */
  function cambiarFoto(mini) {
    var galeria = mini.closest('[data-galeria]');
    var img = galeria && $('.galeria-principal img', galeria);
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = mini.getAttribute('data-src');
    if (mini.getAttribute('data-srcset')) img.setAttribute('srcset', mini.getAttribute('data-srcset'));
    $$('.galeria-mini', galeria).forEach(function (m) {
      var on = m === mini;
      m.classList.toggle('on', on);
      m.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;

    /* Tamaño del perfume */
    if (t.matches('.tamanos input[type="radio"]')) {
      var form = t.form;
      var precio = $('[data-precio-producto]');
      if (precio) {
        var antes = t.getAttribute('data-antes');
        precio.innerHTML = '';
        var s = document.createElement('span');
        s.setAttribute('data-precio', '');
        s.textContent = t.getAttribute('data-precio');
        precio.appendChild(s);
        if (antes) {
          var x = document.createElement('s');
          x.className = 'precio-antes';
          x.textContent = antes;
          precio.appendChild(x);
        }
      }
      var disponible = t.getAttribute('data-disponible') === 'true';
      var boton = form && $('[data-boton-agregar]', form);
      if (boton) {
        boton.disabled = !disponible;
        var txt = $('[data-boton-texto]', boton);
        if (txt) txt.textContent = disponible ? 'Agregar al carrito' : 'Agotado';
      }
      var barraPrecio = $('[data-barra-precio]');
      if (barraPrecio) barraPrecio.textContent = t.getAttribute('data-precio');
      var barraBoton = $('[data-barra-boton]');
      if (barraBoton) { barraBoton.disabled = !disponible; barraBoton.textContent = disponible ? 'Agregar al carrito' : 'Agotado'; }
      var mediaId = t.getAttribute('data-media-id');
      if (mediaId) {
        var mini = $('.galeria-mini[data-media-id="' + mediaId + '"]');
        if (mini) cambiarFoto(mini);
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', t.value);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}
      return;
    }

    /* Filtros: en computadora se aplican al momento; en teléfono con el botón «Ver resultados» */
    var filtros = t.closest('[data-filtros]');
    if (filtros && !filtros.classList.contains('abierto')) { enviarFiltros(filtros); return; }

    /* Orden */
    if (t.matches('[data-orden]')) {
      var f = document.getElementById('form-filtros');
      if (f) enviarFiltros(f);
    }
  });

  function enviarFiltros(form) {
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'form-filtros') return;
    /* No mandar precios vacíos para que la dirección quede limpia */
    $$('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
  }, true);

  /* Barra fija en teléfono: aparece cuando el botón principal ya quedó arriba */
  function barraCompra() {
    var barra = $('[data-barra-compra]');
    var principal = $('[data-boton-agregar]');
    if (!barra || !principal) return;
    var boton = $('[data-barra-boton]', barra);
    var visible = null;
    var pendiente = false;
    function revisar() {
      pendiente = false;
      if (!document.contains(principal)) return;
      var mostrar = principal.getBoundingClientRect().bottom < 0;
      if (mostrar === visible) return;
      visible = mostrar;
      barra.classList.toggle('visible', mostrar);
      barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      if (boton) boton.setAttribute('tabindex', mostrar ? '0' : '-1');
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(revisar);
    }, { passive: true });
    revisar();
  }

  /* ---------- Encuentra tu aroma ---------- */
  function iniciarQuiz(seccion) {
    var tarjeta = $('[data-quiz]', seccion);
    if (!tarjeta || tarjeta.getAttribute('data-listo')) return;
    tarjeta.setAttribute('data-listo', '1');

    var datos = [];
    try { datos = JSON.parse($('[data-quiz-datos]', seccion).textContent); } catch (err) { datos = []; }
    var pasos = $$('[data-paso]', tarjeta);
    var total = pasos.length;
    var txt = $('[data-quiz-paso-txt]', tarjeta);
    var barra = $('[data-quiz-barra]', tarjeta);
    var atras = $('[data-quiz-atras]', tarjeta);
    var nombre = $('[data-quiz-nombre]', tarjeta);
    var resultado = $('[data-quiz-resultado]', tarjeta);
    var grid = $('[data-quiz-grid]', tarjeta);
    var plantilla = $('template[data-quiz-card]', seccion);
    var resp = {};
    var actual = 1;

    function mostrar(n, enfocar) {
      actual = n;
      pasos.forEach(function (p) { p.hidden = Number(p.getAttribute('data-paso')) !== n; });
      resultado.hidden = true;
      txt.textContent = 'Paso ' + n + ' de ' + total;
      barra.style.width = (n / total * 100) + '%';
      atras.hidden = n === 1;
      nombre.hidden = n !== 1;
      if (enfocar) {
        var op = $('[data-paso="' + n + '"] .opt', tarjeta);
        if (op) op.focus({ preventScroll: true });
      }
    }

    function incluye(lista, valor) {
      if (!valor || !lista) return false;
      if (typeof lista === 'string') return lista === valor;
      return lista.indexOf(valor) !== -1;
    }

    function crearTarjeta(d) {
      var nodo = plantilla.content.firstElementChild.cloneNode(true);
      $$('a', nodo).forEach(function (a) { if (a.getAttribute('href') === '#') a.setAttribute('href', d.url); });
      var img = $('img', nodo);
      if (d.image) { img.src = d.image; img.alt = (d.vendor + ' ' + d.title).trim(); }
      else { img.remove(); }
      $('.tarjeta-marca', nodo).textContent = d.vendor || '';
      $('.tarjeta-nombre', nodo).textContent = d.title;
      $('.tarjeta-precio', nodo).textContent = d.price;
      $('[data-tamano]', nodo).textContent = d.size || '';
      var form = $('form', nodo);
      if (d.multi) {
        var enlace = document.createElement('a');
        enlace.className = 'mas';
        enlace.href = d.url;
        enlace.setAttribute('aria-label', 'Elegir tamaño de ' + d.title);
        enlace.innerHTML = $('.mas', form).innerHTML;
        form.replaceWith(enlace);
      } else {
        $('input[name="id"]', form).value = d.id;
        $('.mas', form).setAttribute('aria-label', 'Agregar ' + d.title + ' al carrito');
      }
      return nodo;
    }

    function mostrarResultado() {
      var lista = datos.filter(function (d) { return d.available; });
      if (resp.para) {
        lista = lista.filter(function (d) { return !d.para || d.para === resp.para || d.para === 'Unisex'; });
      }
      var puntuados = lista.map(function (d, i) {
        return { d: d, i: i, s: (incluye(d.aroma, resp.aroma) ? 2 : 0) + (incluye(d.ocasion, resp.ocasion) ? 1 : 0) };
      });
      puntuados.sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); });
      grid.innerHTML = '';
      puntuados.slice(0, 3).forEach(function (x) { grid.appendChild(crearTarjeta(x.d)); });

      pasos.forEach(function (p) { p.hidden = true; });
      resultado.hidden = false;
      txt.textContent = 'Tu resultado';
      barra.style.width = '100%';
      atras.hidden = false;
      nombre.hidden = true;
      var titulo = $('[data-quiz-titulo]', resultado);
      if (titulo) titulo.focus({ preventScroll: true });
      var arriba = tarjeta.getBoundingClientRect().top;
      if (arriba < 0) tarjeta.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
    }

    tarjeta.addEventListener('click', function (e) {
      var opt = e.target.closest('.opt');
      if (opt) {
        var paso = opt.closest('[data-paso]');
        resp[paso.getAttribute('data-clave')] = opt.getAttribute('data-valor');
        if (actual < total) mostrar(actual + 1, e.detail === 0);
        else mostrarResultado();
        return;
      }
      if (e.target.closest('[data-quiz-atras]')) {
        if (!resultado.hidden) mostrar(total, true);
        else if (actual > 1) mostrar(actual - 1, true);
        return;
      }
      if (e.target.closest('[data-quiz-reiniciar]')) {
        resp = {};
        mostrar(1, true);
      }
    });
  }

  /* ---------- Inicio ---------- */
  function iniciar(ctx) {
    moverMenu();
    $$('#aroma', ctx).forEach(iniciarQuiz);
    if (ctx === document || $('[data-barra-compra]', ctx)) barraCompra();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  else iniciar(document);

  /* Editor de temas de Shopify */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
